import Send from "@material-symbols/svg-500/rounded/send.svg?react";
import { memo } from "react";

import { cn } from "@/lib/chillnn/cn";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const SendIcon = (props: SVGIconProps & { rotate?: number }) => {
	const Icon = () =>
		IconCreator({
			...props,
			className: cn(
				props.className,
				`-rotate-45`, // デフォルトで-45度回転させる
			),
			svgIcon: Send,
		});

	return <Icon />;
};

export default memo(SendIcon);
